import { Moon, Sun } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useTheme } from "@/context/ThemeContext";

export function ThemeToggle({ variant = "ghost", size = "icon", className = "" }) {
  const { theme, toggleTheme } = useTheme();

  return (
    <Button
      variant={variant}
      size={size}
      onClick={toggleTheme}
      className={`relative overflow-hidden ${className}`}
      title={theme === "dark" ? "Aktifkan Mode Terang" : "Aktifkan Mode Gelap"}
      data-testid="theme-toggle"
    >
      <Sun className={`h-5 w-5 transition-all duration-300 ${
        theme === "dark" ? "rotate-90 scale-0" : "rotate-0 scale-100"
      }`} />
      <Moon className={`absolute h-5 w-5 transition-all duration-300 ${
        theme === "dark" ? "rotate-0 scale-100" : "-rotate-90 scale-0"
      }`} />
      <span className="sr-only">Toggle theme</span>
    </Button>
  );
}

// Compact version for mobile/tight spaces
export function ThemeToggleCompact({ className = "" }) {
  const { theme, toggleTheme } = useTheme();

  return (
    <button
      onClick={toggleTheme}
      className={`p-2 rounded-lg transition-colors ${
        theme === "dark" 
          ? "bg-slate-700 text-amber-400 hover:bg-slate-600" 
          : "bg-slate-100 text-slate-600 hover:bg-slate-200"
      } ${className}`}
      title={theme === "dark" ? "Mode Terang" : "Mode Gelap"}
      data-testid="theme-toggle-compact"
    >
      {theme === "dark" ? (
        <Sun className="w-4 h-4" />
      ) : (
        <Moon className="w-4 h-4" />
      )}
    </button>
  );
}

export default ThemeToggle;
